export default __webpack_public_path__ + "static/char-s-03-chs-764ba7e163c261c622aba62bdd0e702e.webp";